var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6C14 8.20914 12.2091 10 10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.1156C12 12.812 12.1942 12.5425 12.482 12.4465L16.6486 11.057C16.8767 10.981 17.1233 10.981 17.3514 11.057L21.518 12.4465C21.8058 12.5425 22 12.812 22 13.1156V15.0416C22 18.0976 20.1247 20.8402 17.2777 21.9479C17.0991 22.0174 16.9009 22.0174 16.7223 21.9479C13.8753 20.8402 12 18.0976 12 15.0416V13.1156Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8029 12H4C2.89543 12 2 12.8954 2 14C2 18.4183 5.58172 22 10 22C11.111 22 12.1691 21.7735 13.1307 21.3642C11.4807 19.7244 10.5 17.4648 10.5 15.0416V13.1156C10.5 12.7136 10.6089 12.3307 10.8029 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserShield);
export default __webpack_public_path__ + "static/media/user-shield.fcc7565c136a8aabc4d58e0fe8e05f31.svg";
export { ForwardRef as ReactComponent };